import React, { useState } from 'react'
import { useTranslation } from '../../../common/hooks'
import { useMe } from '../../../common/hooks/useMe'
import { BetmenPage } from '../../../common/components'
import { BooleanFilter } from '../../../common/components/Filters/BooleanFilter'
import {
  getStatusesByReferralStatusFilter,
  PatientReferralsFilter,
} from './referralStatusFilterForPatients'
import { usePatientReferralCount } from '../../doctor/DoctorPatients/hooks/usePatientReferralCount'
import { usePatientProfile } from '../../../common/hooks/usePatientProfile'
import { ReferralList } from '../../doctor/DoctorPatients/components/PatientReferrals/ReferralList'

const PatientReferrals: React.FC = () => {
  const { t } = useTranslation()

  const { data: { me } = {} } = useMe()
  const patientId = me?.profile.id ?? ''

  const [filterInput, setFilterInput] = useState<PatientReferralsFilter>({
    isValid: true,
  })

  const filterData = {
    statuses: getStatusesByReferralStatusFilter(filterInput),
  }

  const { total: totalValid } = usePatientReferralCount({
    patientId,
    statuses: getStatusesByReferralStatusFilter({ isValid: true }),
  })
  const { total: totalExpired } = usePatientReferralCount({
    patientId,
    statuses: getStatusesByReferralStatusFilter({ isExpired: true }),
  })

  const { data: patientProfile } = usePatientProfile({
    variables: { patientId: patientId! },
  })

  return (
    <BetmenPage title={t('menu:patient.referrals')} withoutPadding>
      {patientProfile && (
        <ReferralList
          patientProfile={patientProfile}
          filters={
            <>
              <BooleanFilter
                filterInput={!!filterInput.isValid}
                setFilterInput={(newFilter: boolean) =>
                  setFilterInput((prevInput) => ({
                    ...prevInput,
                    isValid: newFilter,
                  }))
                }
                label={`${t('patients:referral.filter.isValid')} (${totalValid})`}
              />
              <BooleanFilter
                filterInput={!!filterInput.isExpired}
                setFilterInput={(newFilter: boolean) =>
                  setFilterInput((prevInput) => ({
                    ...prevInput,
                    isExpired: newFilter,
                  }))
                }
                label={`${t('patients:referral.filter.isExpired')} (${totalExpired})`}
              />
            </>
          }
          filterData={filterData}
        />
      )}
    </BetmenPage>
  )
}

export { PatientReferrals }
